/**
 * Verified users query – SHXRE verified DB (individual = blue badge, business = gold badge, custom handle).
 */

import {useQuery} from '@tanstack/react-query'

import {fetchVerifiedUser} from '#/lib/api/verified'
import {STALE} from '#/state/queries'

const VERIFIED_ROOT = 'verified'

export function verifiedQueryKey(did: string | null | undefined) {
  return [VERIFIED_ROOT, did ?? ''] as const
}

export function useVerifiedUserQuery(did: string | null | undefined) {
  return useQuery({
    queryKey: verifiedQueryKey(did),
    queryFn: () => fetchVerifiedUser({did: did ?? undefined}),
    staleTime: STALE.MINUTES.FIVE,
    enabled: Boolean(did?.trim()),
  })
}
